import {
  Box,
  Text,
  Flex,
  Button,
  Image,
  ModalHeader,
  ModalBody,
  ModalCloseButton,
} from '@chakra-ui/react'

export default function UnderReview({
  onClose,
  msg,
  subtitle,
}: {
  onClose: () => void
  msg: string
  subtitle: string
}) {
  return (
    <>
      <ModalHeader></ModalHeader>
      <ModalCloseButton />
      <ModalBody mt={2}>
        <Box mb={3} display={'flex'} justifyContent={'center'}>
          <Image
            boxSize="75px"
            src={'/rewards/breakdown/review.svg'}
            alt="Under Review"
          />
        </Box>
        <Text textAlign={'center'} fontWeight={600} fontSize={24} opacity={0.7}>
          {msg}
        </Text>

        <Text fontWeight={400} fontSize={16} textAlign={'center'} mb={6}>
          {subtitle}
        </Text>

        <Flex justifyContent={'center'} gap={4} mb={4}>
          <Button
            px={10}
            bg="lyk-green"
            color="white"
            _hover={{ opacity: 0.7 }}
            size={['sm', 'sm', 'md']}
            fontWeight={500}
            onClick={onClose}
          >
            Okay
          </Button>
        </Flex>
      </ModalBody>
    </>
  )
}
